"use client";
import Image from "next/image";
import { getModel, getUserModel } from "../../../lib/api/generate";
import { isSDXL } from "../../shared/generators/isSDXL";
import { useGenerator } from "@/app/context/GeneratorContext";
import { indexToLocaleKey } from "i18n";
import { transformTags, updateTogglesList } from "@/lib/utils/generation";
import { useGlobalContext } from "@/app/context/store";

export default function StyleToggle({
  generator,
  translations,
}: {
  generator: any;
  translations: any;
}) {
  const {
    state,
    setCreditCost,
    setTagList,
    setResolution,
    setSelectedGenerator,
    setUpscaleState,
    setTagListLoading,
  } = useGenerator();

  const { user } = useGlobalContext();

  const updateTagGroup = async (state: any) => {
    setTagListLoading(true);
    try {
      let model = await getModel(state._id);
      let listOfTogglesJSON = transformTags(
        model.response?.data?.tempTagGroups,
        Number(translations.index),
      );

      if (user._id !== "none") {
        let userModel = await getUserModel(); // User preferences
        const userHiddenTags = userModel.response?.data?.tags.hidden;
        const userSavedTags = userModel.response?.data?.tags.saved;
        // Update toggles list with user preferences from userModel
        const updatedListOfToggles = updateTogglesList(
          listOfTogglesJSON,
          userSavedTags,
          userHiddenTags,
          Number(translations.index),
        );

        setCreditCost(model.response?.data?.creditCost);
        setTagList(updatedListOfToggles);
      } else {
        setCreditCost(model.response?.data?.creditCost);
        setTagList(listOfTogglesJSON);
      }
    } catch (error) {
      console.error("Update Tag Group:", error);
    } finally {
      setTagListLoading(false);
    }
  };

  const buttonStyle = state.selectedGenerator === generator ? "#0772DD" : "#343639";
  const buttonClass =
    "border-[0.5px] border-[#3C3C3C] text-white hover:bg-gray-900 focus:outline-none focus:ring-0 focus:ring-gray-300 font-medium rounded-xl text-sm mx-0 mb-[14px] dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-700 dark:border-gray-700";

  return (
    <button
      type="button"
      onClick={() => {
        if (isSDXL(generator.shortName || "style")) {
          setResolution(10);
        } else if (!isSDXL(generator.shortName || "style")) {
          setResolution(1);
        }
        updateTagGroup(generator);
        // Save selected generator Id to localStorage
        localStorage.setItem("selectedGenerator", generator._id);
        setSelectedGenerator(generator);
      }}
      style={{ backgroundColor: buttonStyle }}
      className={buttonClass}
    >
      <Image
        src={generator.frontend.styleImage}
        width={500}
        height={500}
        alt={generator.names[Number(translations.index)].value + " style image"}
        className="px-auto rounded-xl bg-[#343639] object-cover hover:brightness-105 sm:object-contain"
        placeholder="blur" // Enable the blur-up effect
        blurDataURL={"https://cdn6.imgpog.com/stylePlaceholder.webp"} // The low-res placeholder image
        unoptimized
      />
      <div className="mt-1 truncate">{generator.names[Number(translations.index)].value}</div>
    </button>
  );
}
